import { render, staticRenderFns } from "./PageTOC.vue?vue&type=template&id=01a90aeb&scoped=true"
import script from "./PageTOC.vue?vue&type=script&lang=js"
export * from "./PageTOC.vue?vue&type=script&lang=js"
import style0 from "./PageTOC.vue?vue&type=style&index=0&id=01a90aeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a90aeb",
  null
  
)

export default component.exports